import React from 'react';
import PropTypes from 'prop-types';
import colors from 'common/styles/colors';
import {
  seedActivityListFilters,
  tasksActivityFilters
} from 'home/Widget/helpers/helpers';
import OrgSegmentedBySiteWidget from './OrgSegmentedBySiteWidget';

const WIDGET_NAME = 'org_asset_instrumentation_tasks_by_site';

// Tasks, so Activity rather than Assets.
const tasksSiteTarget = (accountId) => {
  seedActivityListFilters(accountId, tasksActivityFilters());
  return '/activity';
};

const SEGMENT_KEYS = [
  'asset_maintenance_open',
  'instrumentation_open',
  'asset_maintenance_completed',
  'instrumentation_completed'
];

const SEGMENT_COLORS = {
  asset_maintenance_open: colors.warning,
  instrumentation_open: colors.slight,
  asset_maintenance_completed: colors.normal,
  instrumentation_completed: colors.greenL
};

const SEGMENT_I18N = {
  asset_maintenance_open: 'orgView.assetInstrumentationTasks.amOpen',
  instrumentation_open: 'orgView.assetInstrumentationTasks.instOpen',
  asset_maintenance_completed: 'orgView.assetInstrumentationTasks.amCompleted',
  instrumentation_completed: 'orgView.assetInstrumentationTasks.instCompleted'
};

const OrgAssetInstrumentationTasksBySite = props => (
  <OrgSegmentedBySiteWidget
    {...props}
    widgetName={WIDGET_NAME}
    siteLinkTo={tasksSiteTarget}
    emptyMessageKey="orgView.assetInstrumentationTasks.noData"
    emptyMessageDefault="No task data"
    noSitesMessageKey="orgView.assetInstrumentationTasks.noSites"
    noSitesMessageDefault="No sites in this organisation"
    summaryLabelKey="orgView.assetInstrumentationTasks.orgSummary"
    summaryLabelDefault="Asset maint. & instrumentation"
    segmentKeys={SEGMENT_KEYS}
    segmentColors={SEGMENT_COLORS}
    segmentLabelKeys={SEGMENT_I18N}
    getSummaryValue={summary => (summary.total_tasks != null ? summary.total_tasks : 0)}
    renderSummaryMeta={(t, summary) => t('orgView.assetInstrumentationTasks.meta', {
      open: summary.open != null ? summary.open : 0,
      completed: summary.completed != null ? summary.completed : 0,
      defaultValue: '{{open}} open · {{completed}} completed'
    })}
    getSiteRowPrimary={site => (site.total_tasks != null ? site.total_tasks : 0)}
    barSize="medium"
    requireSites={false}
  />
);

OrgAssetInstrumentationTasksBySite.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  widgetsMetadata: PropTypes.object,
  title: PropTypes.string
};

OrgAssetInstrumentationTasksBySite.defaultProps = {
  widgetsMetadata: null,
  title: null
};

export default OrgAssetInstrumentationTasksBySite;
